// src/components/Blog.js
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Blog.css';

function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    fetch('/api/notionBlog')
      .then((res) => {
        if (!res.ok) throw new Error(`Status ${res.status}`);
        return res.json();
      })
      .then((data) => setPosts(data))
      .catch((err) => {
        console.error('Fetch error:', err);
        setErrorMsg(
          err.message.includes('Failed to fetch')
            ? 'Unable to connect to the server.'
            : `Error: ${err.message}`
        );
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="status">Loading blog posts…</p>;
  if (errorMsg) return <p className="status error">{errorMsg}</p>;
  if (!posts.length) return <p className="status">No blog posts found.</p>;

  return (
    <section className="blog" id="blog">
      <h2>Insights & Articles</h2>
      <div className="blog-grid">
        {posts.map((post) => (
          <div className="blog-card" key={post.id}>
            <h3>{post.title}</h3>
            <p>{post.summary}</p>
            <Link to={`/blog/${post.slug}`} className="read-more">
              Read more →
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Blog;
